import { Component } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { LoaderService } from '../../core/services/loader.service';
import { UiLoaderComponent } from 'freyr-ui';

@Component({
    selector: 'app-loader',
    imports: [AsyncPipe, UiLoaderComponent],
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
  constructor(private readonly loader: LoaderService) {}

  get loading$() {
    return this.loader.loading$;
  }
}


